import { Component, OnDestroy, OnInit } from '@angular/core';
import { DisbursedService } from '../../disbursed-service/disbursed.service';
import { Router } from '@angular/router';
import { Routes } from 'src/app/accountancy/utilities/classes/routes.class';
import { Helper } from 'src/app/accountancy/utilities/classes/helper.class';
import { NgxPrintService } from 'ngx-print';
import { ExportAsService } from 'ngx-export-as';
import { AccMessageDialogService } from '../../../../custom-components/acc-message-dialog/acc-message-dialog-service/acc-message-dialog.service';
import { BehaviorSubject, finalize, Subscription, tap } from 'rxjs';
import { DisbursementVoucherIntertace } from 'src/app/accountancy/utilities/interfaces/global.interface';
import { LocalStorageApiService } from 'src/app/accountancy/utilities/services/local-storage-api/local-storage-api.service';

@Component({
  selector: 'app-view-disbursement-voucher',
  templateUrl: './view-disbursement-voucher.component.html',
  styleUrls: ['./view-disbursement-voucher.component.scss'],
})
export class ViewDisbursementVoucherComponent implements OnInit {

  public readonly routes = Routes;
  public readonly Helper = Helper;

  public readonly disbursementVoucher$ = new BehaviorSubject<DisbursementVoucherIntertace | undefined>(undefined);
  public readonly controlNumber$ = new BehaviorSubject<string | undefined>(undefined);
  public readonly type$ = new BehaviorSubject<"Reimbursement" | "Cash Advance" | "Liquidation" | undefined>(undefined);

  constructor(
    private _disburseS: DisbursedService,
    private _router: Router,
    private _ngxPrint: NgxPrintService,
    private _exportAsS: ExportAsService,
    private _msgS: AccMessageDialogService,
    private _localStorageS: LocalStorageApiService,
  ) { }

  public ngOnInit(): void {
    // const subs: Subscription = this._disburseS.voucher.getCurrValue().pipe(
    //   finalize(() => subs.unsubscribe()),
    //   tap(data => {
    //     console.log({ data })
    //     this.disbursementVoucher$.next(data.currVoucher);
    //     this.controlNumber$.next(data.controlNumber);
    //     this.type$.next(data.type);
    //   }),
    //   tap(() => {
    //     const currVoucher = this.disbursementVoucher$.getValue();
    //     if (!currVoucher) {
    //       this._msgS.open({
    //         ...this._getErrMessageProp('No voucher found.'),
    //         onClose: () => this._router.navigate([this.routes.dashboard])
    //       }, true);
    //     }
    //   })
    // ).subscribe();

    const data = this._localStorageS.object.get<{
      type: "Reimbursement" | "Cash Advance",
      disbursementVoucher: DisbursementVoucherIntertace,
      controlNumber: string,
    }>("currentVoucher");

    if (!data?.disbursementVoucher) this._msgS.open({
      ...this._getErrMessageProp('No voucher found.'),
      onClose: () => this._router.navigate([this.routes.dashboard])
    }, true);

    this.disbursementVoucher$.next(data?.disbursementVoucher);
    this.controlNumber$.next(data?.controlNumber);
    this.type$.next(data?.type);

    this._localStorageS.remove("currentVoucher");
  }

  public goBack() {
    this._router.navigateByUrl(this.routes.dashboard);
  }

  private _getErrMessageProp(err?: string) {
    return {
      title: 'Error occurred',
      message: err || 'An error occurred and your request cannot be done.',
      messageType: 'text-red-500',
    };
  }

  public printVoucher() {
    const currVoucher = this.disbursementVoucher$.getValue();
    if (!currVoucher) {
      this._msgS.open(this._getErrMessageProp(), true);
      return;
    }

    try {
      this._ngxPrint.print({
        printSectionId: 'ngx-print-section',
        useExistingCss: true,
        printTitle: `Voucher ${currVoucher?.Info.VoucherNumber}`,
        bodyClass: '',
        openNewTab: true,
        previewOnly: false,
        closeWindow: true,
        printDelay: 0
      });
    } catch (error: any) {
      this._msgS.open(this._getErrMessageProp(), true);
    }
  }

  public downloadVoucher() {
    const currVoucher = this.disbursementVoucher$.getValue();
    if (!currVoucher) {
      this._msgS.open(this._getErrMessageProp(), true);
      return;
    }

    const subsCsv = this._exportAsS.save({ type: 'csv', elementIdOrContent: 'ngx-print-table', }, `Voucher ${currVoucher?.Info.VoucherNumber}`).subscribe({
      error: (err) => {
        console.error({ err })
        this._msgS.open(this._getErrMessageProp(), true);
      },
    })
  }
}
